import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-person-events-shell-page',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './person-events-shell-page.component.html',
  styleUrl: './person-events-shell-page.component.scss',
})
export class PersonEventsShellPageComponent {}
